import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';
import * as guideAction from '../action/guideAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
//Func
import { lsNavigatiorConditionInit } from '../func/lsNavigatiorCondition';
//Part
import DialogMyPhotoMain from './DialogMyPhotoMain';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    if (!localStorage.getItem('NavigatiorCondition')) {
      lsNavigatiorConditionInit();
    }
    let lsObj = JSON.parse(localStorage.getItem('NavigatiorCondition'));
    this.state = {
      navigatiorVisible: lsObj.visible,
      mainPhotoDialog: false,
    }

  }



  _navigatiorConditionSet(value) {
    var obj = {
      visible: value,
    };
    localStorage.setItem('NavigatiorCondition', JSON.stringify(obj));
    this.setState({navigatiorVisible: value});
  }

	render() {
    let stopComp;
    let profileComp;
    let proofComp;
    let emailComp;
    let photoMainComp;
    let webPushComp;
    let requiredCount = 0;
    let optionalCount = 0;
    let comp;

    if (this.props.my.setting.serviceStop === 1) {
      requiredCount++;
      stopComp = (
        <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
          <div style={{padding:'10px'}}>
            <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>サービスが停止中です</div>
            <div>
              現在サービスが停止中の為、プロフィールが非公開です。
            </div>
            <div align='right'>
              <Link to={{ pathname: '/setting/stop/'}}>
                <Button
                  variant="contained"
                  color="primary"
                >
                  再開はこちら
                </Button>
              </Link>
            </div>
          </div>
        </Box>
      )
    }
    else if ( this.props.my.setting.profileWebmasterCheck === 0 && this.props.my.request.profile === 0) {
      requiredCount++;
      profileComp = (
        <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
          <div style={{padding:'10px'}}>
            <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>プロフィールのコメントが未登録です</div>
            <div align='right'>
              <Link to={{ pathname: '/my/comment/'}}>
                <Button
                  variant="contained"
                  color="primary"
                >
                  プロフィールのコメントを編集
                </Button>
              </Link>
            </div>
          </div>
        </Box>
      )
    }
    else {
      if (this.props.my.proof.person === 0　&& this.props.my.proof.credit === 0 && this.props.my.request.proof.person === 0) {
        requiredCount++;
        proofComp = (
          <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
            <div style={{padding:'10px'}}>
              <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>本人証明が申請されていません</div>
              {
                (this.props.my.profile.userdata_sex === 'men') ? (
                  <div>
                    本人証明を申請いただくと<span className='link' onClick={ () => this.props.guideApproachMailSet(true) }><u>無料メール</u></span>でアプローチできます。
                  </div>
                ): (
                  <div>
                    本人証明を申請いただくと<span className='link' onClick={ () => this.props.guidePaymentSet(true, 'women') }><u>すべて無料</u></span>でご利用いただけます。
                  </div>
                )
              }
              <div align='right'>
                <Link to={{ pathname: '/my/proof/person'}}>
                  <Button
                    variant="contained"
                    color="secondary"
                  >
                    本人証明を申請する
                  </Button>
                </Link>
              </div>
            </div>
          </Box>
        )
      }
      else {
        if (!this.props.my.photo.main.uri && this.props.my.request.photo === 0) {
          optionalCount++;
          photoMainComp = (
            <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
              <div style={{padding:'10px'}}>
                <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>メイン写真が未登録です</div>
                <div>
                  メイン写真を掲載して、出会いのチャンスを広げましょう。
                </div>
                <div>
                  <span
                  className='link'
                    onClick={ () => this.props.helpOpen('id', 502) }
                  >
                    <u>メイン写真を掲載した方が良い理由</u>
                  </span>

                </div>
                <div align='right'>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={ () => this.setState({mainPhotoDialog: true}) }
                  >
                    メイン写真を登録する
                  </Button>
                </div>
              </div>

              <DialogMyPhotoMain
                open={ this.state.mainPhotoDialog }
                close={ () => this.setState({mainPhotoDialog: false}) }
              />
            </Box>
          )
        }
      }
      if (!this.props.my.setting.email) {
        optionalCount++;
        if (this.props.my.request.email) {
          emailComp = (
            <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
              <div style={{padding:'10px'}}>
                <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>メールアドレスの登録が完了していません</div>

                <div style={{fontSize:'1.1em', fontWeight:'bold'}}>
                  {this.props.my.request.email} に認証メールを送信しました
                </div>
                <div>
                  本文に記載された認証コードをクリックしてください。
                </div>

                <div style={{fontSize:'1.2em', fontWeight:'bold',margin:'5px'}}>{this.props.my.setting.emailUnAttestation}</div>
                <div style={{color:'#666'}}>

                  認証メールが届かない場合
                  <span
                  className='link'
                    onClick={ () => this.props.helpOpen('category','bounce') }
                  >
                    <u>コチラ</u>
                  </span>をご確認いただき、
                  再度<Link to={{ pathname: '/setting/email/'}}><u>メールアドレスの登録</u></Link>を行ってください。
                </div>
              </div>
            </Box>
          )
        }
        else {
          emailComp = (
            <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
              <div style={{padding:'10px'}}>
                <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>メールアドレスが未登録です</div>
                <div>
                  未登録だとお得なキャンペーンやログインできない時などの大切なお知らせが送信できません。
                </div>

                <div align='right'>
                  <Link to={{ pathname: '/setting/email/'}}>
                    <Button
                      variant="contained"
                      color="primary"
                    >
                      メールアドレスの登録
                    </Button>
                  </Link>
                </div>
              </div>
            </Box>
          )
        }
      }
      else {
        if (process.env.NODE_ENV === 'production' && this.props.my.setting.webpushCount === 0) {
          if (('serviceWorker' in navigator) && ('PushManager' in window)) {
            optionalCount++;
            webPushComp = (
              <Box boxShadow={2} style={{border:'solid 1px #FFBC57', background:'#FFE7C2', margin:'5px 0px'}} className='round12'>
                <div style={{padding:'10px'}}>
                  <div style={{color:'#754600',fontSize:'1.2em',fontWeight:'bold'}}>プッシュ通知が未登録です</div>
                  <div>
                    登録すれば受信メールがリアルタイムに確認できます。
                  </div>
                  <div align='right'>
                    <Link to={{ pathname: '/setting/webpush/'}}>
                      <Button
                        variant="contained"
                        color="primary"
                      >
                        プッシュ通知の登録
                      </Button>
                    </Link>
                  </div>
                </div>
              </Box>
            )
          }
        }
      }
    }

    if (requiredCount > 0) {
      comp = (
        <div>
          { stopComp }
          { profileComp }
          { proofComp }
        </div>
      )
    }
    else if (optionalCount > 0) {
      comp = (
        <div>

            <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
              <Grid
                item
              >
                <h3>使い方ナビ</h3>
              </Grid>
              <Grid item  style={{position:"relative"}}>

                  <Switch
                    onChange={ (event) => this._navigatiorConditionSet(event.target.checked) }
                    checked={ this.state.navigatiorVisible }
                  />
                  {
                    (this.state.navigatiorVisible === false) && (
                      <span style={{position:'absolute',top:'3px',right:'6px'}}>
                        <span className='badge'> </span>
                      </span>
                    )
                  }

              </Grid>
            </Grid>




          <Collapse in={this.state.navigatiorVisible}>
            <div>
              { emailComp }
              { photoMainComp }
              { webPushComp }
            </div>
          </Collapse>
        </div>
      )
    }

		return (
			<div id='navigator_block' className={this.props.className}>
        { comp }
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
    ...guideAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
